<div [@slideDown] class="sticky-top alert alert-info mt-2 screen-share-banner" role="alert">
  <div class="lead fs-5 text-center mb-3">
    An evaluator from the Arizona Department of Education has requested to observe your session. By accepting, you allow
    the evaluator to view only the screen, window, or browser tab you select when prompted by your browser. The session
    will not be recorded, and you can stop sharing at any time.
  </div>
  <div class="d-flex justify-content-center gap-2">
    <button class="btn btn-danger" (click)="declineRequest()">Decline Screen Share Request</button>
    <button class="btn btn-success" (click)="acceptRequest()">Accept Screen Share Request</button>
  </div>
</div>
